import BlogHeader from "./header";
import BlogContent from "./content";
import BlogSidebar from "./sidebar";

function Blog_components() {
  return (
    <div id="blog">
      <BlogHeader />
      <div className="blog-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-12">
              <BlogContent />
            </div>
            <div className="col-lg-4 col-12">
              <BlogSidebar />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog_components;
